<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
    @if(!processing() && pool) {
      <app-competition-timeline [competitionConfig]="pool.getCompetitionConfig()"></app-competition-timeline>
    }

    <div class="d-flex flex-wrap justify-content-between my-3">
      <h2 class="me-2 text-truncate">
        <fa-icon [icon]=faUserSecret></fa-icon> scoutingslijst
      </h2>
      @if(!processing() && pool) {
        <div>
          @if( pool.getAssemblePeriod().isIn()) {
            <button class="btn btn-secondary mx-2"
              [routerLink]="['/pool/formation/assemble', pool.getId()]">
              <fa-icon [icon]=faUsers></fa-icon> <span class="ms-1 d-none d-sm-inline">
                mijn team</span>
            </button>
          }
          <button (click)="linkToSearch(pool)" type="button" class="btn btn-secondary ms-2">
            <fa-icon [icon]=faSearch></fa-icon> <span class="d-none d-sm-inline ms-1">zoeken</span>
          </button>
        </div>
      }
    </div>    
    
    @if(processing()){
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    @if(alert){
    <ngb-alert [type]="alert.type" (closed)="alert = undefined">{{ alert.message }}</ngb-alert>
    }
    @if(scoutingList && scoutingList.scoutedPlayers.length === 0) {
      <ngb-alert type="info">je hebt nog geen spelers gescout, begin met zoeken</ngb-alert>
    }

    @if(!processing() && pool) {
    <table class="table">
      <tbody>
        @for (scoutedPlayer of scoutingList.scoutedPlayers; track scoutedPlayer.getId()) {
        <tr (click)="linkToPlayer(pool, scoutedPlayer.getS11Player(), gameRoundNumber)" class="pointer">
          <!-- <ng-template let-player="scoutedPlayer.getPlayer()"> -->
          @let tmplAssembleFormation = assembleFormation();          
          @if(tmplAssembleFormation){            
            <td class="text-end" (click)="$event.stopPropagation()">
              @if(showCopyToTeam(tmplAssembleFormation, scoutedPlayer.getS11Player())) {
                <button 
                (click)="copyToTeam(tmplAssembleFormation, scoutedPlayer.getS11Player())" type="button" class="btn btn-sm btn-secondary">
                <fa-icon [icon]=faSignInAlt></fa-icon>
                <span class="d-none d-sm-inline ms-1">plaats in team</span>
              </button>
              }
            </td>
          }
          <td>
            <app-lineicon [line]="scoutedPlayer.getS11Player().getLine()"></app-lineicon>
          </td>
          <td>
            <span>{{scoutedPlayer.getPerson().getName()}}</span>
          </td>
          @let currentPlayer = getCurrentPlayer(scoutedPlayer.getS11Player());
          <td>            
            @if(currentPlayer){
              <app-team-name [team]="currentPlayer.getTeam()"></app-team-name>
            }
          </td>
          <td class="text-end pe-0">
            @if(currentPlayer){
              <se-marketvalue [marketValue]="currentPlayer.getMarketValue()"></se-marketvalue>
            }
          </td>
          <td class="text-end pe-0">
            <span class="badge bg-totals" style="width: 2rem">{{getTotalPoints(pool,scoutedPlayer.getS11Player())}}</span>
          </td>
          <td (click)="$event.stopPropagation()">
            @if(pool) {
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="openRemoveModal(scoutedPlayer, pool)">
                <fa-icon [icon]=faTrashAlt></fa-icon>
              </button>
            }
          </td>
          <!-- </ng-template> -->
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
</div>
@if(!processing() && pool) {
<app-pool-navbar [current]="Scouting" [pool]="pool" [poolUser]="poolUserFromSession">
</app-pool-navbar>
}